module.exports = __webpack_public_path__ + "static/media/INSIGHTS_Main_Logo.4f6c959f.png";